// src/components/itinerary/TimeSlotItem.tsx
// src/components/itinerary/TimeSlotItem.tsx
// Update the TimeSlotItem component to have fixed heights

import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { Activity, TimeSlot } from '../../contexts/ItineraryContext';

interface TimeSlotItemProps {
  slot: TimeSlot;
  activity: Activity | undefined;
  isDraggingOver: boolean;
  getActivityIcon: (type: string) => JSX.Element;
  onRemoveActivity: () => void;
}

const TimeSlotItem: React.FC<TimeSlotItemProps> = ({
  slot,
  activity,
  isDraggingOver,
  getActivityIcon,
  onRemoveActivity
}) => {
  return (
    <Box
      sx={{
        p: 1,
        mb: 1,
        height: '90px', // Fixed height to prevent jumping
        minHeight: '90px',
        border: '1px dashed',
        borderColor: isDraggingOver ? 'primary.main' : 'divider',
        bgcolor: isDraggingOver ? 'action.hover' : 'background.paper',
        display: 'flex',
        alignItems: 'center',
        borderRadius: 1,
        transition: 'background-color 0.2s ease, border-color 0.2s ease',
        position: 'relative' // Helps with positioning of drop indicators
      }}
    >
      <Typography variant="body2" sx={{ 
        width: 80, 
        flexShrink: 0, 
        fontWeight: 'medium',
        position: 'absolute',
        left: 10,
        top: 10
      }}>
        {slot.time}
      </Typography>
      
      <Box sx={{ 
        ml: 10, // Add margin to account for the fixed position time
        width: '100%',
        display: 'flex',
        alignItems: 'center'
      }}>
        {activity ? (
          <Box sx={{ 
            flexGrow: 1, 
            display: 'flex', 
            alignItems: 'center',
            height: '70px', // Fixed content height
            overflow: 'hidden' // Hide overflow content
          }}>
            {getActivityIcon(activity.type)}
            <Box sx={{ ml: 1, flexGrow: 1, overflow: 'hidden' }}>
              <Typography variant="body1" noWrap>
                {activity.title}
              </Typography>
              <Typography variant="body2" color="text.secondary" noWrap>
                {activity.location}
              </Typography>
              {activity.duration && (
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }} noWrap>
                  Duration: {activity.duration}
                </Typography>
              )}
            </Box>
            <IconButton 
              size="small" 
              color="error"
              onClick={onRemoveActivity}
              sx={{ ml: 1 }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ 
            textAlign: 'center',
            width: '100%',
            py: 2 // Add padding to ensure consistent height
          }}>
            Drop an activity here
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default TimeSlotItem;